<template>
	<managing-section :is-table="true">
		<template slot="infoSection">
			<span class="section__info__left"></span>
			<div class="section__info__right">
				<div class="section__info__items">
					<button class="btn-excel" @click="csvDown">
						액셀다운로드
					</button>
				</div>
				<div class="section__info__items">
					<select class="select" v-model="limit" @change="getList(0)">
						<option
							v-for="item in limitList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</div>
			</div>
		</template>
		<table class="table-main">
			<thead>
				<tr>
					<th>회원번호</th>
					<th>닉네임</th>
					<th>이메일주소</th>
					<th>이름</th>
					<th>전화번호</th>
					<th>가입일시</th>
					<th>마지막<br />접속일시</th>
					<th>SNS연동</th>
					<th>성별</th>
					<th>나이</th>
					<th>피부타입</th>
					<th>단말기</th>
					<th>리뷰수</th>
					<th>당첨수</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in list" :key="item.idRegister">
					<td>{{ item.idRegister }}</td>
					<td>
						<router-link
							class="link"
							:to="`/register/register-info/${item.idRegister}`"
							target="_blank"
						>
							{{ item.nickname }}
						</router-link>
					</td>
					<td>{{ item.email }}</td>
					<td class="white-space__nowrap">{{ item.userName }}</td>
					<td>{{ item.userTel }}</td>
					<td class="white-space__nowrap">
						{{ item.activatedDate }}
					</td>
					<td class="white-space__nowrap">
						{{ item.lastAccessDate }}
					</td>
					<td>{{ item.sns }}</td>
					<td>{{ item.gender }}</td>
					<td>{{ item.age }}</td>
					<td>{{ item.skinType }}</td>
					<td>{{ item.os }}</td>
					<td>{{ item.reviewCnt }}</td>
					<td>{{ item.winCnt }}</td>
				</tr>
			</tbody>
		</table>
		<pagination-box
			slot="pagination"
			:limit="limit"
			:offset="offset"
			:total-item="contentTotal"
			@to="getList($event.offset)"
		/>
	</managing-section>
</template>
<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import util from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'CastUserTable',
		components: {
			ManagingSection,
			PaginationBox,
		},
		props: {
			type: {
				type: String,
				required: true,
			},
		},
		data() {
			return {
				limit: 10,
				offset: 0,
				contentTotal: 0,
				list: null,
			};
		},
		computed: {
			apiPath() {
				return `/register/${this.type.toLowerCase()}`;
			},
			...mapState({
				params: state => state.modal.params,
				osList: state => state.register.osList,
			}),
			...mapGetters(['getLimitList', 'getItemById']),
			limitList() {
				return this.getLimitList();
			},
		},
		created() {
			this.getList();
		},
		methods: {
			getOs(regId, apns) {
				const result = this.osList.find(
					type => type.id === `${!!regId}${!!apns}`
				);
				return result ? result.value : '-';
			},
			getTime(string) {
				return string
					? moment(string, 'YYYYMMDDHHmmss').format(
							'YYYY-MM-DD HH:mm:ss'
						)
					: '-';
			},
			async getList(offset = 0) {
				try {
					this.offset = offset;
					const params = {
						idPouch: this.params.castId,
						limit: this.limit,
						offset: this.offset,
					};
					const { data } = await this.$axiosNoah.get(
						`${this.apiPath}`,
						{ params }
					);
					this.contentTotal = data.contentTotal;
					this.list = data[`cast${this.type}UserList`].map(item => {
						item.skinType = (
							this.getItemById('skinType', item.skinType) || {
								name: '-',
							}
						).name;
						item.gender = (
							this.getItemById('gender', item.gender) || {
								name: '-',
							}
						).name;
						item.os = this.getOs(item.regId, item.apns);
						item.activatedDate = this.getTime(item.activatedDate);
						item.lastAccessDate = this.getTime(item.lastAccessDate);
						return item;
					});
				} catch (err) {
					console.error(err);
				}
			},
			async csvDown() {
				try {
					const params = { idPouch: this.params.castId };
					const { data, config } = await this.$axiosNoah.get(
						`${this.apiPath}/export`,
						{ params }
					);
					const rows = data.map(item => [
						item.activatedDate,
						item.age,
						item.apns,
						item.email,
						item.fileDir,
						item.fileSaveName,
						item.gender,
						item.idRegister,
						item.lastAccessDate,
						item.nickname,
						item.regId,
						item.reviewCnt,
						item.skinType,
						item.sns,
						item.userName,
						item.userTel,
						item.winCnt,
					]);
					util.getCsv(
						[rows],
						undefined,
						[
							[
								'activatedDate',
								'age',
								'apns',
								'email',
								'fileDir',
								'fileSaveName',
								'gender',
								'idRegister',
								'lastAccessDate',
								'nickname',
								'regId',
								'reviewCnt',
								'skinType',
								'sns',
								'userName',
								'userTel',
								'winCnt',
							],
						],
						`pick_${this.params.castId}_register_${moment().format('YYYYMMDD')}`,
						config.url
					);
				} catch (err) {
					console.error(err);
				}
			},
		},
	};
</script>
